import type { OrganizationSettingsEntry, UpdateSettingsBody } from '@obras/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../lib/api.js';

const settingsKey = ['configuracoes'] as const;

export function useSettings() {
  return useQuery({
    queryKey: settingsKey,
    queryFn: ({ signal }) => api.get<OrganizationSettingsEntry>('/configuracoes', signal),
  });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateSettingsBody) =>
      api.patch<OrganizationSettingsEntry>('/configuracoes', body),
    /*
     * Invalida tudo, não só as configurações.
     *
     * Mudar o intervalo de visita muda o prazo de toda obra que não tem
     * intervalo próprio, e mudar o fuso muda a data que o servidor considera
     * "hoje". Recarregar só esta tela deixaria a lista de obras mostrando os
     * prazos antigos até alguém navegar de novo.
     */
    onSuccess: () => queryClient.invalidateQueries(),
  });
}
